import React from "react";
import { AppLayout } from "../../Layouts";
import PageLayout from "../../Layouts/PageLayout";
import { useTranslation } from "react-i18next";
import SettingsContentLayout from "../../Layouts/SettingsContentLayout";
import ProfilePageContent from "../../Components/Features/Settings/ProfilePageContent";

function ProfilePage() {
  const { t } = useTranslation();
  return (
    <AppLayout>
      <PageLayout title={t("user_profile")}>
        <div className="h-fit md:h-screen w-full bg-white rounded-xl shadow-accent-foreground shadow-2xl ">
          <SettingsContentLayout>
            <ProfilePageContent/>
          </SettingsContentLayout>
        </div>
      </PageLayout>
    </AppLayout>
  );
}

export default ProfilePage;
